export const GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER = 1;
